// extracted by mini-css-extract-plugin
module.exports = {"list":"AmenityFilter-module--list--644325","label":"AmenityFilter-module--label--a2d4f9"};